import { gql } from "@apollo/client";

export const USER_FIELDS_FRAGMENT = gql`
	fragment UserFields on User {
		id
		fullname
		email
		username
		phoneNumber
		role
		nativeLanguage
		registeredCourses
		capabilities
		createdAt
		updatedAt
		subscription
		currentStreak
		lastDailyGoalReached
		dailyGoalAmount
		dailyGoalType
		avatar {
			... on StringAvatar {
				value
			}
			... on EmbededMedia {
				id
				filename
				filepath
				type
				mimetype
				title
				metaData {
					start
					end
					player
					aspectRatio
				}
				uploadedLocs
				imageSizes
			}
		}
		authenticationModel
		fcmTokens
		studyTimeReminder
		hasUsedTrialVersion
		affiliate
		claimNoAffiliate
		myAffiliateId
		verified
		emailVerified
		phoneVerified
		status
		pushNotifTokens {
			installationId
			token
		}
		languageLevel
		subscriptionPlan {
			plan
			name
			title
			startDate
			endDate
			amount
			transactionId
			status
		}
		favoriteTopics
		learningGoal
	}
`;
